import uuidv4 from 'uuid/v4';

import { dispatchPromise, fetchResources } from './action-helpers';

const DEFAULT_CUSTOM_FIELD_PROPS = {
    type: null,
    name: null,
    id: null,
    description: undefined,
    projects: [],
    associations: [],
    hidden: [],
    currency: undefined,
    options: undefined
};

export const createCustomField = customFieldProps => {
    return dispatchPromise({
        type: 'CUSTOM_FIELD_CREATE_REQUESTED',
        payload: {
            customField: Object.assign({}, DEFAULT_CUSTOM_FIELD_PROPS, customFieldProps, {
                id: uuidv4()
            })
        }
    });
}

export const fetchCustomFields = (projectId, all) => fetchResources('CUSTOM_FIELDS_FETCH_REQUESTED', { projectId }, all);

export const fetchCustomFieldsValues = (association, associationId) => {
    return dispatchPromise({
        type: 'CUSTOM_FIELDS_VALUES_FETCH_REQUESTED',
        payload: {
            association,
            associationId
        }
    });
}

export const updateCustomField = (customFieldId, customFieldProps, preventSave) => {
    return dispatchPromise({
        type: 'CUSTOM_FIELD_UPDATE_REQUESTED',
        preventSave,
        payload: {
            customFieldId,
            customFieldProps
        }
    });
}

export const removeCustomField = customFieldId => {
    return dispatchPromise({
        type: 'CUSTOM_FIELD_REMOVE_REQUESTED',
        payload: {
            customFieldId
        }
    });
}

export const setCustomFieldValue = (association, associationId, fieldId, value) => {
    return dispatchPromise({
        type: 'CUSTOM_FIELD_VALUE_SET_REQUESTED',
        payload: {
            association,
            associationId,
            fieldId,
            value
        }
    });
}

export const setCustomFieldsValue = updateProps => {
    return dispatchPromise({
        type: 'CUSTOM_FIELDS_VALUE_SET_REQUESTED',
        payload: {
            updateProps
        }
    });
}
